export default {
  loading: 0
};
